import { styled, Typography, ButtonBase } from '@mui/material'
import { Logout as LeaveIcon } from '@mui/icons-material'
import { CallType } from '@weblite/ts-action/media-proxy'
import { HallAvatar } from '$common/avatar'
import { TribuneActiveAudioWaves } from '$common/tribune-active-audio-waves'
import { useOpenedRoomId } from '$logic/opened-room'
import { resetCallAndShowNPS, useCallStorage } from '$logic/call'
import { openCall as openCallPanel } from '$logic/router'
import { useHall } from '$logic/hall/react-hook'
import { t } from '$i18n'
import { CALL_BAR_HEIGHT } from '$comp/_app/components/chat/components/conf'
import { LiveActiveIcon } from '$common/live-active-icon/live-active-icon'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const Root = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  background: linear-gradient(180deg, #ff61a3 0%, #ff1a79 100%);

  width: 100%;
  height: ${CALL_BAR_HEIGHT}px;
  padding: 0 16px 0 12px;
  overflow: hidden;
`

const GroupInfo = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  z-index: 1;
`

const LeaveButton = styled(ButtonBase)`
  overflow: hidden;
  padding: 6px 8px;
  border-radius: 8px;
  background-color: #ffffffd9;

  & > span {
    line-height: 20px;
  }
  & > svg {
    color: ${({ theme }) => theme.palette.error.main};
    margin-right: 4px;
    width: 20px;
    height: 20px;
  }
`

interface PropTypes {
  isInRoom?: boolean
  callType: CallType
}
export function ChannelCallBar({ isInRoom = false, callType }: PropTypes) {
  const openedRoomId = useOpenedRoomId()
  const { roomId, isParticipating, name: currentCallName } = useCallStorage()
  const { entity: hall } = useHall(roomId)

  const name = currentCallName || hall?.name

  const showGroupInfo = !isInRoom || openedRoomId !== roomId

  return (
    <Root disableRipple disableTouchRipple onClick={openCallPanel}>
      <GroupInfo>
        {showGroupInfo ? (
          <HallAvatar size={AvatarSize._2XS} roomId={roomId} />
        ) : callType === 'live' ? (
          <LiveActiveIcon />
        ) : (
          <TribuneActiveAudioWaves />
        )}

        <Typography
          variant="subtitle3"
          color={isParticipating ? 'white' : 'semiBlack'}
          noWrap
        >
          {showGroupInfo
            ? name
            : t(`call.current${callType === 'live' ? 'Live' : 'Tribune'}`)}
        </Typography>
      </GroupInfo>

      <LeaveButton
        onClick={e => {
          e.stopPropagation()
          resetCallAndShowNPS()
        }}
      >
        <Typography variant="subtitle3" color="error">
          {t('call.leave')}
        </Typography>

        <LeaveIcon />
      </LeaveButton>
    </Root>
  )
}
